import React, { Component } from 'react';
import { Provider } from "react-redux";
import AppContainer from "./containers/app";
import "./App.scss";
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Auth from './views/auth/auth'
import createStore from './store'

export const store = createStore();

class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route path="/authorize" exact={true} component={Auth} />
            <Route path="/" exact={true} component={AppContainer} />
            <Route component={AppContainer} />
          </Switch>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
